// src/features/live-board/components/BoardCountTile.tsx
//
// A count-only board column (`board.pending`, `board.room_not_ready`):
// unlike `board.at_device`/`board.needs_help`, these two ids resolve to a
// plain number server-side (`V2BoardFinItMetricDefinitions.BoardPending`/
// `BoardRoomNotReady`, `Domain/Services/V2ChainOpsMetricDefinitions.CountResult`)
// — no per-guest row list exists for them, so this tile shows the number the
// API actually states rather than inventing rows the backend does not send
// (see the unit's own evidence file, "Design choices").
import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import { WidgetCard } from '@/components/common/WidgetCard';
import { DASH } from '@/lib/analyticsFormat';
import { MetricStamp } from './MetricStamp';
import type { MetricResultDto } from '@/types/analyticsV2';

interface BoardCountTileProps {
  title: string;
  icon?: React.ReactNode;
  metric: MetricResultDto | undefined;
  loading: boolean;
}

export const BoardCountTile: React.FC<BoardCountTileProps> = ({ title, icon, metric, loading }) => (
  <WidgetCard title={title} icon={icon}>
    {loading ? (
      <Skeleton width={64} height={48} />
    ) : (
      <Box>
        <Typography variant="h3" sx={{ fontWeight: 700, lineHeight: 1.1 }}>
          {!metric || metric.absent || typeof metric.value !== 'number' ? DASH : metric.value}
        </Typography>
        {metric && <MetricStamp stamp={metric.stamp} />}
      </Box>
    )}
  </WidgetCard>
);

export default BoardCountTile;
